module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07416_banner_800x600.e83a6711.png";